import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-weight-bold" }
const _hoisted_2 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.visible) = $event)),
    width: "800"
  }, {
    activator: _withCtx(({}) => [
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: _ctx.open
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.dialog.button')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Form, { ref: "observer" }, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_FocusLock, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline font-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.funktion.dialog.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "pb-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.title.lieferantenrechnung')), 1),
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pt-3 pb-0 multiline-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.teilnehmerFunktionApiDtoCopy.hatRechnungenNurViaVetdata,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.hatRechnungenNurViaVetdata) = $event)),
                              "hide-details": true
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.verzichtpostszustellunglieferantenrechnung')), 1),
                                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.verzichtpostszustellunglieferantenrechnung.hinweis')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pt-0 multiline-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.emailSendenLieferantRechnung,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emailSendenLieferantRechnung) = $event)),
                              "hide-details": true,
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkboxLieferantenrechnungenUpdated($event.target.checked)))
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.funktion.dialog.zustellungemaillieferantenrechnung')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_Field, {
                              modelValue: _ctx.teilnehmerFunktionApiDtoCopy.emailLieferantRechnung,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.emailLieferantRechnung) = $event)),
                              name: "LieferantenEmail",
                              rules: _ctx.getValidation('teilnehmerFunktionApiDto.emailLieferantRechnung') + '|' + _ctx.emailLieferantRechnungenValidation
                            }, {
                              default: _withCtx(({ errors, field }) => [
                                _createVNode(_component_v_text_field, _mergeProps(field, {
                                  modelValue: _ctx.teilnehmerFunktionApiDtoCopy.emailLieferantRechnung,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.emailLieferantRechnung) = $event)),
                                  disabled: !_ctx.emailSendenLieferantRechnung,
                                  label: _ctx.$t('einstellungen.funktion.dialog.emaillieferantenrechnung') + '*',
                                  placeholder: "...",
                                  "error-messages": errors
                                }), null, 16, ["modelValue", "disabled", "label", "error-messages"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "pb-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.title.tvsdokumente')), 1),
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pt-3 pb-0 multiline-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.teilnehmerFunktionApiDtoCopy.hatTvsDokumenteNurDigital,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.hatTvsDokumenteNurDigital) = $event)),
                              "hide-details": true
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.zustellunglieferantenrechnung')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pt-0 multiline-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.emailSendenTvsDokument,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailSendenTvsDokument) = $event)),
                              "hide-details": true,
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkboxTvsDokumenteUpdated($event.target.checked)))
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.zustellungemailtvsdokumente')), 1),
                                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('einstellungen.funktion.dialog.zustellungemailtvsdokumente.hinweis')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_Field, {
                              modelValue: _ctx.teilnehmerFunktionApiDtoCopy.emailTvsDokument,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.emailTvsDokument) = $event)),
                              name: "TvsDokumenteEmail",
                              rules: _ctx.getValidation('teilnehmerFunktionApiDto.emailTvsDokument') + '|' + _ctx.emailTvsDokumentValidation
                            }, {
                              default: _withCtx(({ errors, field }) => [
                                _createVNode(_component_v_text_field, _mergeProps(field, {
                                  modelValue: _ctx.teilnehmerFunktionApiDtoCopy.emailTvsDokument,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.teilnehmerFunktionApiDtoCopy.emailTvsDokument) = $event)),
                                  disabled: !_ctx.emailSendenTvsDokument,
                                  label: _ctx.$t('einstellungen.funktion.dialog.emailtvsdokumente') + '*',
                                  placeholder: "...",
                                  "error-messages": errors
                                }), null, 16, ["modelValue", "disabled", "label", "error-messages"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_actions, { class: "ml-4 pt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: !meta.valid,
                          color: "primary",
                          variant: "flat",
                          type: "submit",
                          class: "modalbutton mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "modalbutton mb-3",
                          variant: "flat",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.visible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ], 32)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}